import { UiSchema } from '@rjsf/utils'
import validator from '@rjsf/validator-ajv8'
import Ajv from 'ajv'
import yaml, { YAMLException } from 'js-yaml'
import { merge } from 'lodash'
import { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import ErrorComponent from '@/components/ErrorComponent'

import Form, { extractUiSchema } from './components/Form'
import Monaco, { OnChange } from './components/Monaco'
import useDatasource from './hooks/useDatasource'
import { Datasource } from './interfaces'
import dump from './utilities/dumpYaml'

export function Schema() {
  const [datasource, setDatasource] = useDatasource(true)
  const [validSchema, setValidSchema] = useState({})

  const uiSchema: UiSchema = merge(extractUiSchema(validSchema), {
    'ui:options': {
      submitButtonOptions: {
        submitText: 'Save'
      }
    },
    callbackUrl: {
      'ui:widget': 'CallBackUrl'
    }
  })

  useEffect(() => {
    const isSchemaValid = new Ajv().validateSchema(datasource.schema || {})
    if (isSchemaValid) {
      setValidSchema(datasource.schema)
    }
  }, [datasource])
  const handleChange: OnChange = (value = '') => {
    try {
      const schema = yaml.load(value) as Datasource['schema']
      setDatasource(datasource => ({ ...datasource, schema }))
    } catch (error) {
      if (error instanceof YAMLException) return
      throw error
    }
  }

  return (
    <div className="flex flex-1">
      <div className="flex flex-1 flex-col">
        <div className="bg-gray-100 px-4 py-2 text-xs">Connection Form Schema</div>
        <Monaco language="yaml" defaultValue={dump(datasource.schema)} onChange={handleChange} />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="bg-gray-100 px-4 py-2 text-xs">Connection Form Preview</div>
        {/* @ts-expect-error */}
        <ErrorBoundary
          fallbackRender={({ error }) => (
            <div className="mx-auto max-w-2xl">
              <ErrorComponent errors={error ? [error] : []} />
            </div>
          )}
        >
          <Form
            className="flex flex-1 flex-col gap-4 px-12 py-4"
            validator={validator}
            schema={validSchema || { type: 'object', properties: {}, required: [] }}
            uiSchema={uiSchema}
            formData={datasource.schema}
          />
        </ErrorBoundary>
      </div>
    </div>
  )
}
